import { compose } from 'redux'

// higher-order components
import withQueryResults from 'components/shared/withQueryResults'
import withQuery from './withQuery'

// presentational component
import UI from './UI'

export default compose(
  withQueryResults, // for handling query errors
  withQuery // for fetching account data
)(UI)
